import CardContent from '@mui/material/CardContent';
import {
  Button,
  Card,
  CardActions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import DisabledCardState from '../Cards/DisabledCardState';
import { useUiState } from '@app/utils/UiStateHook';
import { FC } from 'react';
import { DateTime } from 'luxon';
import { useScienceSomethingCard2Controller } from '@components/ScienceSomething/UseScienceSomethingCard2Controller';
import { InfoBubble } from '../InfoBubble';

export interface ScienceSomethingCard2Props {
  startDate: string | DateTime;
  groupId: number;
}

export const ScienceSomethingCard2: FC<ScienceSomethingCard2Props> = ({ startDate, groupId }) => {
  const { enabled, disabledMessage, open, openDialog, closeDialog, content, learnMoreDisabled } =
    useScienceSomethingCard2Controller(startDate, groupId);

  const uiState = useUiState(enabled);
  return (
    <>
      <Card
        variant={'elevation'}
        sx={{
          borderRadius: 4,
          border: '1px solid',
          borderColor: uiState.borderColor,
        }}
      >
        <CardContent>
          <div
            className="title-with-info"
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: 6, // space between title and info icon
              flexWrap: 'nowrap',
            }}
          >
            <Typography variant="h5" component="div" color={enabled ? 'primary' : 'textDisabled'}>
              Science Something
            </Typography>
            <InfoBubble title="Science Something">
              Science Something is updated each Friday with new, nerdy information about exercise.
            </InfoBubble>
          </div>
          {!enabled && (
            <DisabledCardState
              disabledMessage={disabledMessage}
              src="/assets/svg/science-something.svg"
              alt="Get stoked!"
            />
          )}
          {enabled && (
            <>
              <div className="card-content-wrapper">
                <img src={'/assets/svg/science-something.svg'} alt={'Science Something'} className="card-logo" />
                <Typography variant="smallCursive" component="div" className="card-copy">
                  {content.title}
                </Typography>
              </div>
              <CardActions
                sx={{
                  alignItems: 'end',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flexDirection: 'column',
                }}
              >
                <Button disabled={learnMoreDisabled} variant="contained" color="primary" onClick={openDialog}>
                  Learn More
                </Button>
              </CardActions>
            </>
          )}
        </CardContent>
      </Card>
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>{content.title}</DialogTitle>
        <DialogContent
          className={content.body?.includes('barriers') ? 'science-something-barriers' : undefined}
          dangerouslySetInnerHTML={{
            __html: content.body || '',
          }}
        ></DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={closeDialog}>
            Got It!
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
